export default __webpack_public_path__ + "static/media/MasterCard_Logo.svg.e4f38402.png";